<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-11-10 17:05:26
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-11 13:39:47
-->
<template>
  <div class="innovative innovative-accuaspects" :class="{textj: language != 'en'}" ref="accuaspects">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/pc/innovate/product-list-bj.png')" alt="" srcset="">
      <div class="innovative-bj-title center_up_down_left_right" v-html="$t('product.accuaspects.title')"></div>
    </div>
    <div class="p-t-60 overhid">
      <div class="innovative-container">
        <div class="innovative-wrap-item flex p-b-150" :class="{align_items_center: language != 'en'}">
          <div class="flex_1">
            <img class="" :src="$t('product.accuaspects.list[0].img')" alt="" srcset="">
          </div>
          <div class="flex_1 p-l-80">
            <div class="innovative-item-title" v-html="$t('product.accuaspects.list[0].title')"></div>
            <div class="p-t-46 p-b-30 textj">
              <p v-for="item, index in $t('product.accuaspects.list[0].des')" :key="index" v-html="item"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="innovative-wrap-item p-t-0 posrel accuaspects-characteristics">
        <img v-if="language != 'en'" class="wh100" :src="$t('product.accuaspects.list[1].img')" alt="" srcset="">
        <div class="t-0 wh100 innovative-container p-t-50 p-b-50" :class="language != 'en' ? 'posabs' : ''">
          <div class="innovative-characteristics trans-list wh100">
            <div class="innovative-item-title p-l-15" v-html="$t('product.accuaspects.list[1].title')"></div>
            <div class="flex p-t-46">
              <div :class="['flex_1 flex flex_col align_items_center']" v-for="item, index in $t('product.accuaspects.list[1].des')" :key="index" :style="index == 1 ? (language != 'en' ? 'padding: 0 6%;' : 'padding: 0 4%;') : ''">
                <div :class="['flex flex_col align_items_center', index == 1 ? 'p-r-40' : '']">
                  <div style="height: 62px;">
                    <img class="" :src="item.img" alt="" srcset="">
                  </div>
                  <div class="innovative-wrap-item-title textc fz-22 p-b-20 p-t-15" :class="{'lh-30': language == 'en'}" v-html="item.title"></div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div :class="['flex_1 flex flex_col align_items_center']" v-for="item, index in $t('product.accuaspects.list[1].des')" :key="index" :style="index == 1 ? (language != 'en' ? 'padding: 0 6%;' : 'padding: 0 4%;') : ''">
                <div>
                  <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="accuaspects-advantages">
        <div class="innovative-container">
          <div class="innovative-accuaspects-m-h trans-list">
            <div class="innovative-item-title widauto ilblk fz-14 p-l-15" :class="language == 'en' ? 'p-r-130' : 'p-r-60'" v-html="$t('product.accuaspects.list[2].title')"></div>
            <div class="flex justify_content_center">
              <img class="wid100" :src="$t('product.accuaspects.list[2].img')" alt="" srcset="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="innovative-container">
      <div class="innovative-wrap-item p-t-50 p-b-50 article">
        <div class="innovative-item-title" v-html="$t('product.accuaspects.article.title')"></div>
        <div class="p-t-15">
            <p class="p-t-15" v-for="item, index in $t('product.accuaspects.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['language'])
  }
}
</script>

<style lang="less">
@import "~@/styles/pc/products.less";
</style>

<style lang="less" scoped>
.pc .innovative-accuaspects {
  .innovative-characteristics {
    padding: 50PX 48PX;
  }
  .accuaspects-advantages {
    background: #F8FBFF;
    padding: 50PX 0;
  }
  .innovative-accuaspects-m-h {
    background: #FFFFFF;
    box-shadow: 0PX 4PX 12PX 4PX rgba(81, 170, 255, 0.1);
    padding: 44PX 65PX;
    font-size: 24PX;
    font-weight: 600;
  }
}

.pc.en .innovative-accuaspects {
  .accuaspects-characteristics {
    background-image: url('~@/assets/images/innovate/AccuASPECTS/2.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 1820PX) {
  .pc.zh .innovative-accuaspects {
    .accuaspects-characteristics {
      height: 600PX;
    }
  }
}
@media screen and (max-width: 1442PX) {
  .pc.zh .innovative-accuaspects {
    .accuaspects-characteristics {
      height: 630PX;
    }
  }
}
</style>
